import * as Sentry from '@sentry/browser';
import {getCookieCountryCode} from './CountryRestriction/CountryRestrictionUtility';

export function initSentry() {

  let environment = 'Production';
  if (window.location.hostname.match(/faulhaber\.wwwserver\.net$/)) {
    environment = 'Testing';
  } else if (window.location.hostname.match(/iveins\.de$/)) {
    environment = 'Development';
  }

  Sentry.init({
    dsn: 'https://bc23a1bed09e42c4901e84c0b3f2b364@sentry.andersundsehr.com/5',

    // This enables automatic instrumentation (highly recommended),
    // but is not necessary for purely manual usage
    // If you only want to use custom instrumentation:
    // * Remove the `BrowserTracing` integration
    // * add `Sentry.addTracingExtensions()` above your Sentry.init() call
    integrations: [new Sentry.BrowserTracing()],

    environment,

    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 1.0, // TODO LOWER! maybe to 0.2?

    // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [
      /^\/(.*)/, // currentDomain
      /www\.faulhaber\.com\/(.*)$/,
      /faulhaber\.com\.cn\/(.*)$/,
      /faulhaber\.wwwserver\.net\/(.*)$/,
      /iveins\.de\/(.*)$/,
    ],
  });

  const country = getCookieCountryCode();
  if (country) {
    Sentry.setTag('country', country);
  }
}
